export const PENDING_CHAT_SESSION_ID = -1;
export const ABANDONED_CHAT_SESSION_ID = -2;

export function isSessionIdReusable(sessionId: number): boolean {
    return sessionId >= PENDING_CHAT_SESSION_ID;
}

export function isSessionAbandoned(sessionId: number): boolean {
    return sessionId == ABANDONED_CHAT_SESSION_ID;
}
